<template>
    <p class="error" v-if="message">{{ messageFirst }}</p>
</template>

<script>
  export default {
    props: {
      message: {
        type: [String, Array],
        default: '',
      },
    },
    computed: {
      messageFirst() {
        return Array.isArray(this.message) ? this.message[0] : this.message;
      }
    }
  }
</script>
